import { render, staticRenderFns } from "./LayoutAside.vue?vue&type=template&id=3a0d13ac&scoped=true"
import script from "./LayoutAside.vue?vue&type=script&lang=js"
export * from "./LayoutAside.vue?vue&type=script&lang=js"
import style0 from "./LayoutAside.vue?vue&type=style&index=0&id=3a0d13ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0d13ac",
  null
  
)

export default component.exports